import { ViewModel, View, ObservableArray } from "binder"
import { ProductionStopListEditorView } from "./productionStopListEditor-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { IProductionStopList } from "../IProductionStopList";
import { ProductLine, ProductLineSelectorViewModel } from "../Selectors/productLineSelector-viewModel";
import { WorkStation, WorkStationSelectorViewModel } from "../Selectors/workStationSelector-viewModel";
import { StopReasonSelectorViewModel } from "../Selectors/stopReasonSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { TimePart, TimeSelectorViewModel } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class ProductionStopListEditorViewModel extends ViewModel implements IProductionStopList, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;

        this.workStationSelector = new WorkStationSelectorViewModel(this);
        this.productLineSelector = new ProductLineSelectorViewModel(this);
        this.productLineSelector.onSelectionChanged = x => {
            this.onProductLineChanged(x);

            this.workStationSelector.productLineId = x.id;
            this.workStationSelector.refresh();
            this.workStationSelector.onSelectionChanged = x => this.onWorkStationChanged(x);
        }

        this.stopReasonSelector = new StopReasonSelectorViewModel(this);
        
        this.timeSelector = new TimeSelectorViewModel(this);
        const m = new TimePart(this);
        m.no = 10;
        const h = new TimePart(this);
        h.no = 20;
        this.timeSelector.selectedMinute = m;
        this.timeSelector.selectedHour = h;
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionStopListEditorView();
    }
    public getTypeId(): string {
        return "VM-6C22C3EF-E2C1-424C-9444-6CA98B0471BF"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set time(v: string) { this._time = v; } public get time(): string { return this._time; } private _time: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set productLineSelector(v: ProductLineSelectorViewModel) { this._productLineSelector = v; } public get productLineSelector(): ProductLineSelectorViewModel { return this._productLineSelector; } private _productLineSelector: ProductLineSelectorViewModel;
    public set workStationId(v: string) { this._workStationId = v; } public get workStationId(): string { return this._workStationId; } private _workStationId: string;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set workStationSelector(v: WorkStationSelectorViewModel) { this._workStationSelector = v; } public get workStationSelector(): WorkStationSelectorViewModel { return this._workStationSelector; } private _workStationSelector: WorkStationSelectorViewModel;
    public set stopReasonId(v: string) { this._stopReasonId = v; } public get stopReasonId(): string { return this._stopReasonId; } private _stopReasonId: string;
    public set stopReasonName(v: string) { this._stopReasonName = v; } public get stopReasonName(): string { return this._stopReasonName; } private _stopReasonName: string;
    public set stopReasonSelector(v: StopReasonSelectorViewModel) { this._stopReasonSelector = v; } public get stopReasonSelector(): StopReasonSelectorViewModel { return this._stopReasonSelector; } private _stopReasonSelector: StopReasonSelectorViewModel;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;

    onProductLineChanged(productLine: ProductLine) {
        this.productLineId = productLine?.id;
    }
    setProductLineId(id: string) {
        this.productLineSelector.selectById(id);
    }
    getProductLineId(): string {
        return this.productLineSelector.selectedItem?.id;
    }

    onWorkStationChanged(workStation: WorkStation) {
        this.workStationId = workStation?.id;
    }
    setWorkStationId(id: string) {
        this.workStationSelector.selectById(id);
    }
    getWorkStationId(): string {
        return this.workStationSelector.selectedItem?.id;
    }

    setStopReasonId(id: string) {
        this.stopReasonSelector.selectById(id);
    }
    getStopReasonId(): string {
        return this.stopReasonSelector.selectedItem?.id;
    }

    closePopup(result?: any) {

    }

    async cloneTo(productionStopList: IProductionStopList) {
        productionStopList.id = this.id;
        productionStopList.date = this.date;
        productionStopList.time = this.time;
        productionStopList.productLineName = this.productLineName;
        productionStopList.workStationName = this.workStationName;
        productionStopList.stopReasonName = this.stopReasonName;
        productionStopList.personnelName = this.personnelName;
        productionStopList.timeSelector = this.timeSelector;
        productionStopList.timeSelector.selectedHour = this.timeSelector.selectedHour;
        productionStopList.timeSelector.selectedMinute = this.timeSelector.selectedMinute;
        productionStopList.setProductLineId(this.getProductLineId());
        productionStopList.setWorkStationId(this.getWorkStationId());
        productionStopList.setStopReasonId(this.getStopReasonId());
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت توقفات');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('توقفات با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت توقفات', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getProductLineId())) {
            result.push('خط تولید مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getWorkStationId())) {
            result.push('ایستگاه کاری مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getStopReasonId())) {
            result.push('علت توقف مشخص نشده است.');
        }
        if (this.date == null) {
            result.push('تاریخ مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(productionStopList: IProductionStopList): Promise<any>;
}

export class ProductionStopListInserter implements IServerUpdater {
    async execute(productionStopList: IProductionStopList): Promise<any> {
        try {
            let time = productionStopList.timeSelector.selectedHour.no * 60 + productionStopList.timeSelector.selectedMinute.no;
            let result = await ServerConnection.callServer('/Complex/ProductionStopServices/CreateProductionStop', {
                ProductLineId: productionStopList.getProductLineId(),
                WorkStationId: productionStopList.getWorkStationId(),
                StopReasonId: productionStopList.getStopReasonId(),
                From: productionStopList.date.add(time, "m")
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ProductionStopListUpdater implements IServerUpdater {
    async execute(productionStopList: IProductionStopList): Promise<any> {
        try {
            let time = productionStopList.timeSelector.selectedHour.no * 60 + productionStopList.timeSelector.selectedMinute.no;
            let result = await ServerConnection.callServer('/Complex/ProductionStopServices/UpdateProductionStop', {
                ProductionStopId: productionStopList.id,
                ProductLineId: productionStopList.getProductLineId(),
                WorkStationId: productionStopList.getWorkStationId(),
                StopReasonId: productionStopList.getStopReasonId(),
                From: productionStopList.date.add(time, "m")
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
